<template>
<div>
    <v-menu 
      ref="showPicker"
      :close-on-content-click="false"
      v-model="showPicker"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
      :disabled="showComponentsManager"
    >
        <v-text-field
          slot="activator"
          v-model="copyDate"
          :label="title"
          prepend-icon="event"
        ></v-text-field>
        <v-date-picker
          v-model="copyDate"
          no-title
          scrollable
          @input="showPicker = false; $emit('update-date', copyDate)"
        ></v-date-picker>
    </v-menu>
</div>
  
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    title: {
      type: String,
      default: 'Select Date'
    },
    date: {
      type: String
    },
    status: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showPicker: false,
      copyDate: this.date,
    };
  },
  computed: {
    ...mapGetters('survey', ['selectedSurvey']),
    ...mapGetters(['currentUser']),
    showComponentsManager: function () {
      if (this.currentUser.role === 'manager' && this.status) {
        return true;
      }
      return false;
    },
  },
};

</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/client/rounds/commons/DatePickerCustom.vue